import i18n from 'modules/core/lib/i18n'
import type { PeriodRoleContext } from 'modules/planning/roles/base/resourceHeader'

export type HeadcountRow = {
  parentWithChildren: boolean
  type: string
  name: string
  directManager: string
  role: string
  level: string
  salary: string
  workingTime: string
  startDate: string
  endDate?: string
}

export type HeadcountColumn = {
  label: string
  render: (item: HeadcountRow) => { type: 'text'; value: string }
}

export function getColumnDefinition(_roleContext: PeriodRoleContext): HeadcountColumn[] {
  return [
    {
      label: i18n.t('planning.employee_sheet.columns.type'),
      render: (item) => ({
        type: 'text' as const,
        value: item.type,
      }),
    },
    {
      label: i18n.t('planning.employee_sheet.columns.name'),
      render: (item) => ({
        type: 'text' as const,
        value: item.name,
      }),
    },
    {
      label: i18n.t('planning.employee_sheet.columns.direct_manager'),
      render: (item) => ({
        type: 'text' as const,
        value: item.directManager,
      }),
    },
    {
      label: i18n.t('planning.employee_sheet.columns.role'),
      render: (item) => ({
        type: 'text' as const,
        value: item.role,
      }),
    },
    {
      label: i18n.t('planning.employee_sheet.columns.level'),
      render: (item) => ({
        type: 'text' as const,
        value: item.level,
      }),
    },
    {
      label: i18n.t('planning.employee_sheet.columns.salary'),
      render: (item) => ({
        type: 'text' as const,
        value: item.salary,
      }),
    },
    {
      label: i18n.t('planning.employee_sheet.columns.working_time'),
      render: (item) => ({
        type: 'text' as const,
        value: item.workingTime,
      }),
    },
    {
      label: i18n.t('planning.employee_sheet.columns.start_date'),
      render: (item) => ({
        type: 'text' as const,
        value: item.startDate,
      }),
    },
    {
      label: i18n.t('planning.employee_sheet.columns.end_date'),
      render: (item) => ({
        type: 'text' as const,
        value: item.endDate ?? '',
      }),
    },
  ]
}
